import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Backdrop } from '@/components/atoms';
import { RootState } from '@/store/store';
import Image from 'next/image';

const CustomMuiBackdrop = styled(Backdrop)`
  &.MuiBackdrop-root {
    position: fixed;
    z-index: 1000;
    min-height: 100%;
    background-color: rgba(245, 245, 245, 0.3);
    color: ${props => props.theme.paletteDefault.primary.main};
  }
`;

const LoadingOverlay: React.FC = ({}) => {
  const loading = useSelector(
    (state: RootState) => state.loadingOverlayReducer
  );
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (loading.filters || loading.products) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [loading]);

  return (
    <CustomMuiBackdrop open={show}>
      <div
        style={{
          zIndex: 1001,
          position: 'fixed',
          top: '50%',
          left: '50%',
          marginLeft: '-54px',
        }}>
        <Image
          src="/asset/M_Gif_website.gif"
          alt="mirta logo"
          width={108}
          height={32}
          unoptimized={true}
        />
      </div>
    </CustomMuiBackdrop>
  );
};

export default LoadingOverlay;
